<template>
  <div id="footer">
    <div class="pa-5 animate__animated animate__pulse">
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <div class="d-flex justify-center align-center">
            <div class="d-flex justify-center align-center">
              <div class="pa-2">
                <v-avatar color="primary" size="100">
                  <v-img
                    contain
                    lazy-src="../../assets/img/logo-teman-bakat.png"
                    max-height="150"
                    max-width="250"
                    src="../../assets/img/logo-teman-bakat.png"
                  ></v-img>
                </v-avatar>
              </div>
              <div class="pa-2">
                <div class="font-weight-bold">Teman Bakat</div>
                <div>
                  <p>
                    Komplek Surapati Core Blok C-22 Lt.2, Jalan PHH Mustofa,
                    Cibeunying Kidul, Kota Bandung, Jawa Barat 40192
                  </p>
                  <p>+6282128211907</p>
                  <p>temanbakat@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div>
            <div class="font-weight-bold pa-2">Produk</div>
            <div class="d-flex">
              <div class="pa-2">
                Psikotes <br />
                Konseling & Konsultasi <br />
                Self Development Games <br />
                Self Development Journey <br />
                Simple Psychology <br />
              </div>
              <div class="pa-2">
                Training <br />
                Course <br />
                Artikel & Video <br />
              </div>
              <div class="pa-2">
                The Journey <br />
                Personal Profile <br />
                CV Maker <br />
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <div class="d-flex justify-center align-center">
            <div class="font-weight-bold">
              Contact Us <br />
              <div class="d-flex">
                <div class="ml-1">
                  <a
                    target="_blank"
                    href="https://www.instagram.com/temanbakat/"
                  >
                    <v-img
                      contain
                      lazy-src="../../assets/img/logo-teman-bakat.png"
                      max-height="40"
                      max-width="40"
                      src="../../assets/img/penjurusan/sosmed-instagram.png"
                    >
                    </v-img>
                  </a>
                </div>
                <div class="ml-1">
                  <a target="_blank" href="https://www.tiktok.com/@temanbakat">
                    <v-img
                      contain
                      lazy-src="../../assets/img/logo-teman-bakat.png"
                      max-height="40"
                      max-width="40"
                      src="../../assets/img/penjurusan/sosmed-tiktok.png"
                    ></v-img>
                  </a>
                </div>
                <div class="ml-1">
                  <a target="_blank" href="https://wa.wizard.id/63b84f">
                    <v-img
                      contain
                      lazy-src="../../assets/img/logo-teman-bakat.png"
                      max-height="40"
                      max-width="40"
                      src="../../assets/img/penjurusan/sosmed-wa.png"
                    ></v-img>
                  </a>
                </div>
                <div class="ml-1">
                  <v-img
                    contain
                    lazy-src="../../assets/img/logo-teman-bakat.png"
                    max-height="40"
                    max-width="40"
                    src="../../assets/img/penjurusan/sosmed-youtube.png"
                  ></v-img>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="d-flex justify-start align-center">
            <div class="mx-2">
              <a href="/privacy" style="text-decoration: none; color: white"
                >Privacy Policy</a
              >
            </div>
            <div class="mx-2">
              <a href="/privacy" style="text-decoration: none; color: white"
                >Term & Condition</a
              >
            </div>
            <div class="mx-2">
              <a href="#" style="text-decoration: none; color: white">FAQ</a>
            </div>
            <div class="mx-2">
              <a href="#" style="text-decoration: none; color: white"
                >Partnership</a
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
#footer {
  color: white;
  background-color: #24182d;
}
</style>
